// Можно пробросить массив валидных урлов
const currentRouteMatcher = (routeForMatching, route) => {
  if (Array.isArray(routeForMatching)) {
    return routeForMatching.some((nextRoute) => nextRoute === route.name);
  }
  return route.name === routeForMatching;
};

const isTenderPage = (route) => {
  return route.matched.some((value) => value.name === 'tender');
};

const isTenderOffers = (route) => {
  return route.matched.some((value) => value.name === 'tender-offers');
};

const isIncomingTenderPage = (route) => {
  return route.matched.some((value) => value.name === 'incoming-tender');
};

const isIncomingTenderInfoPage = (route) => {
  return route.matched.some((value) => value.name === 'incoming-tender-info');
};

const isTenderSummaryPage = (route) => {
  return (
    (route.params.incomingTenderId || route.params.tenderId) &&
    !route.params.tenderListId &&
    !route.params.incomingTenderListId
  );
};

export {
  isTenderPage,
  currentRouteMatcher,
  isTenderSummaryPage,
  isIncomingTenderPage,
  isIncomingTenderInfoPage,
  isTenderOffers,
};
